import { useState } from "react";
import useData from "./useData";

const useUser = () => {
  const { executeAction, getFromServer } = useData();

  const [user, setUser] = useState(null);
  const [territoryAssignments, setTerritoryAssignments] = useState([]);

  const getUser = async (userId) => {
    const results = await getFromServer({
      entityName: "User",
      id: userId,
    });

    setUser(results);
  };

  const getTerritoryAssignemnts = async (userId) => {
    const results = await executeAction({
      entityName: "User",
      action: "getTerritoryAssignments",
      data: { userId },
    });

    if (results?.isSuccessful) {
      setTerritoryAssignments(results.data || []);
    } else {
      setTerritoryAssignments([]);
    }
  };

  const getScheduleStatus = async (userId) => {
    const results = await executeAction({
      entityName: "User",
      action: "getScheduleStatus",
      data: { userId },
    });

    return results?.isSuccessful ? results : null;
  };

  return {
    user,
    getUser,
    getTerritoryAssignemnts,
    territoryAssignments,
    getScheduleStatus,
  };
};

export default useUser;
